import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import { ButtonGroup, GuideTypographyLine } from "../../CellComponent";
import { LastCard } from "../common";

export const Content_12_1_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),

  InstructionWithContent(`typography_3`, [
    [
      ButtonGroup(
        [
          { text: "A. 상태가 나빠졌다고 판단하고 즉시 멈춘다." },
          {
            text: "B. 감정의 찌꺼기가 빠져나가는 자연스러운 정화 과정이라 여기고 계속 나아간다.",
          },
          { text: "C. 쉽고 빠르게 마음을 편안하게 해줄 다른 방법을 찾는다." },
        ],
        { id: "quiz1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_4"),

  Header1("typography_5"),
  Instruction("typography_6"),
  Instruction("typography_7"),

  InstructionWithContent(`typography_8`, [
    [
      ButtonGroup(
        [
          { text: "A. 그 생각이 나의 진짜 모습이자 진실이라고 굳게 믿는다." },
          { text: "B. 왜 그런 부정적인 생각을 했는지 치밀하게 분석한다." },
          { text: "C. 주변에서 들려오는 소음으로 여기며 판단 없이 관찰한다." },
        ],
        { id: "quiz2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_9"),

  Header1("typography_10"),
  Instruction("typography_11"),
  Instruction("typography_12"),

  InstructionWithContent(`typography_13`, [
    [
      ButtonGroup(
        [
          { text: "A. 내 잘못을 찾아내어 분석하는 반성의 4단계" },
          { text: "B. 인지하고 수용하며 관찰하고 분리하는 RAIN 기법" },
          { text: "C. 부정적인 생각을 지우고 긍정으로 채우는 마인드 컨트롤" },
        ],
        { id: "quiz3", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz3", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_14"),

  Header1("typography_15"),
  Instruction("typography_16"),
  Instruction("typography_17"),

  InstructionWithContent(`typography_18`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 긍정적인 생각으로만 가득 차서 슬픔을 전혀 느끼지 않는 상태",
          },
          { text: "B. 부정적인 생각을 모두 지워내고 머리를 텅 비운 상태" },
          { text: "C. 마음속 생각 및 감정들과 건강한 관계를 맺은 상태" },
        ],
        { id: "quiz4", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz4", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_19"),

  Header1("typography_20"),
  Instruction("typography_21"),
  Instruction("typography_22"),

  Header1("typography_23"),
  Instruction("typography_24"),
  Instruction("typography_25"),

  ...LastCard,
];
